import axios from "../axios";

const updateBankAccount = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('/bank-account/updateBankAccount', data, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateBankAccount;
